<template>
  <v-container fluid class="px-2">
    <v-tabs grow v-model="activeTab" background-color="colorComponentsBackground" height="30">
      <v-tab>{{ $t('label.table') }}</v-tab>
      <v-tab>{{ $t('label.calendar') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <v-sheet :height="$store.state.windowSize.y - 104">
          <v-data-table
            :items="groupView ? groupedVisits : tableData"
            :headers="headers"
            item-key="id"
            :height="$store.state.windowSize.y - 158"
            fixed-header
            must-sort
            disable-pagination
            hide-default-footer
            dense
            show-expand
            single-expand
            :expanded.sync="expanded"
            :loading="loaderStatus"
            class="tableCursor"
          >
            <template v-slot:expanded-item="{ item }">
              <td v-if="groupView" :colspan="headers.length">
                <v-data-table
                  :items="item.children"
                  :headers="groupHeaders"
                  item-key="id"
                  :height="200"
                  fixed-header
                  must-sort
                  disable-pagination
                  hide-default-footer
                  dense
                  group-by="timearrive"
                  class="tableCursor"
                  style="background-color: #fafafa"
                >
                  <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
                    <th class="blue-grey lighten-4">
                      <v-icon @click="toggle">{{ isOpen ? mdiChevronUp : mdiChevronDown }} </v-icon>
                      &nbsp;
                      {{ $t('label.arrival') }}:
                      {{ formatDateTZ(items[0].timearrive, items[0].timezone, $store.state.auth.df.dateYearTime) }}
                      &nbsp;&nbsp;
                      {{ $t('label.departure') }}:
                      {{ formatDateTZ(items[0].timedeparture, items[0].timezone, $store.state.auth.df.dateYearTime) }}
                    </th>
                    <th class="px-1 blue-grey lighten-4">
                      <v-simple-checkbox
                        class="pa-0 ma-0"
                        v-model="groupKeys[items[0].groupID]"
                        @click="groupDaysCheck(items[0].groupID)"
                      />
                    </th>
                  </template>
                  <template v-slot:item="{ item }">
                    <tr @click="openPlannedVisitDetail(item)">
                      <td class="pl-5">{{ `${item.name} ${item.surname}` }}</td>
                      <td class="px-1 d-flex">
                        <v-simple-checkbox v-model="item.checked" />
                        <v-tooltip v-if="item.approvalstatus == 1" right :open-delay="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="green" v-on="on" v-bind="attrs">{{ mdiCheckBold }}</v-icon>
                          </template>
                          <span>{{ $t('label.approved') }}</span>
                        </v-tooltip>
                        <v-tooltip v-if="item.approvalstatus == 2" right :open-delay="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="red" v-on="on" v-bind="attrs">{{ mdiCloseThick }}</v-icon>
                          </template>
                          <span>{{ $t('label.declined') }}</span>
                        </v-tooltip>
                        <v-tooltip v-if="item.approvalstatus == 10" right :open-delay="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="blue" v-on="on" v-bind="attrs">{{ mdiAccountArrowLeft }}</v-icon>
                          </template>
                          <span>{{ $t('label.inObject') }}</span>
                        </v-tooltip>
                        <v-tooltip v-if="item.approvalstatus == 11" bottom :open-delay="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="grey darken-2" v-on="on" v-bind="attrs">{{ mdiAccountArrowRight }}</v-icon>
                          </template>
                          <span>{{ $t('label.visitClosed') }}</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </td>
            </template>
            <template v-slot:item="{ item }">
              <tr @click="openPlannedVisitDetail(item)">
                <td @click.stop class="px-0">
                  <v-btn v-if="groupView && item.children.length > 1" icon @click="expandRow(item)">
                    <v-icon>{{ expanded.includes(item) ? mdiChevronUp : mdiChevronDown }}</v-icon>
                  </v-btn>
                </td>
                <td v-if="!item.isGroup" class="px-1">{{ `${item.name} ${item.surname}` }}</td>
                <td v-else class="px-1">{{ $tc('label.group') }}</td>
                <td class="px-1">{{ `${item.employeeName} ${item.employeeSurname}` }}</td>
                <td class="px-1">{{ `${item.plannerName} ${item.plannerSurname}` }}</td>
                <td class="px-1">{{ `${item.approverName} ${item.approverSurname}` }}</td>
                <td class="px-1">{{ item.areaName }}</td>
                <td class="px-1">{{ formatDateTZ(item.timearrive, item.timezone, $store.state.auth.df.dateYearTime) }}</td>
                <td class="px-1">{{ formatDateTZ(item.timedeparture, item.timezone, $store.state.auth.df.dateYearTime) }}</td>
                <td class="px-1">
                  <span class="d-flex">
                    <v-simple-checkbox v-model="item.checked" @click="groupAllChildsCheck(item)" />
                    <v-tooltip v-if="item.approvalstatus == 1" bottom :open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="green" v-on="on" v-bind="attrs">{{ mdiCheckBold }}</v-icon>
                      </template>
                      <span>{{ $t('label.approved') }}</span>
                    </v-tooltip>
                    <v-tooltip v-else-if="item.approvalstatus == 2" bottom :open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="red" v-on="on" v-bind="attrs">{{ mdiCloseThick }}</v-icon>
                      </template>
                      <span>{{ $t('label.declined') }}</span>
                    </v-tooltip>
                    <v-tooltip v-else-if="item.approvalstatus == 10" bottom :open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="blue" v-on="on" v-bind="attrs">{{ mdiAccountArrowLeft }}</v-icon>
                      </template>
                      <span>{{ $t('label.inObject') }}</span>
                    </v-tooltip>
                    <v-tooltip v-else-if="item.approvalstatus == 11" bottom :open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="grey darken-2" v-on="on" v-bind="attrs">{{ mdiAccountArrowRight }}</v-icon>
                      </template>
                      <span>{{ $t('label.visitClosed') }}</span>
                    </v-tooltip>
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-row class="my-1">
            <v-col cols="2">
              <v-btn
                v-if="tableData.length > 0"
                color="colorSave"
                block
                @click="approveMultiple(1)"
                :disabled="!tableData.some((item) => item.checked)"
                >{{ $t('label.approve') }}
              </v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn
                v-if="tableData.length > 0"
                color="colorDelete"
                block
                @click="approveMultiple(2)"
                :disabled="!tableData.some((item) => item.checked)"
                >{{ $t('label.reject') }}
              </v-btn>
            </v-col>
            <v-col cols="2">
              <v-switch
                class="px-0 ma-0"
                v-model="groupView"
                inset
                :label="groupView ? $tc('label.group', 2) : $t('label.table')"
              ></v-switch>
            </v-col>
            <v-col cols="3" />
            <v-col cols="2"><v-btn @click="exportToCSV()">export</v-btn></v-col>
            <v-col cols="1" class="text-right">
              <v-simple-checkbox v-if="tableData.length > 0" v-model="multiselect" @click="multiselectCheck()" class="mt-1 mr-8">
              </v-simple-checkbox>
            </v-col>
          </v-row>
        </v-sheet>
      </v-tab-item>
      <v-tab-item>
        <v-toolbar flat>
          <v-btn icon class="ma-2" @click="getCalendarRef().prev()">
            <v-icon>{{ mdiChevronLeft }}</v-icon>
          </v-btn>
          <v-select
            v-model="calPeriod"
            :items="listPeriods"
            item-text="name"
            item-value="value"
            :return-object="false"
            hide-details
            flat
            solo
          />
          <v-btn icon class="ma-2" @click="getCalendarRef().next()">
            <v-icon>{{ mdiChevronRight }}</v-icon>
          </v-btn>
          <v-spacer />
          <v-toolbar-title v-if="calValue">
            {{ formatDate(calValue, 'MMMM YYYY') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-sheet :height="$store.state.windowSize.y - 210">
          <v-calendar
            ref="calendar"
            v-model="calValue"
            :weekdays="weekdays"
            :type="calPeriod"
            :events="calEvents"
            @click:event="calShowEvent"
            @click:more="viewDay"
            event-overlap-mode="stack"
            :event-overlap-threshold="30"
            :event-color="getEventColor"
          />
        </v-sheet>
      </v-tab-item>
    </v-tabs-items>
    <!--DIALOGS----------------------------------------------------------------------->
    <v-dialog v-model="plannedVisitDetail" width="900">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.approval') }}
          <v-spacer /><v-icon large @click="plannedVisitDetail = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-sheet style="overflow-y: auto; overflow-x: hidden" :height="$store.state.windowSize.y - 250" :max-height="460">
          <v-card-text class="pa-3">
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.visiting') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.employeeSurname }} {{ plannedVisitSelected.employeeName }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.plannedBy') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.plannerName }} {{ plannedVisitSelected.plannerSurname }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.visitor') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.name }} {{ plannedVisitSelected.surname }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.document') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ getDocumentType(plannedVisitSelected.documenttype) }} - {{ plannedVisitSelected.documentno }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.phone') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.phone }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.email') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.email }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.company') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>{{ plannedVisitSelected.companyname }}</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.car') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>{{ plannedVisitSelected.carplate }} - {{ plannedVisitSelected.cartype }} {{ plannedVisitSelected.carcolor }}</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.plannedArrival') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3 v-if="plannedVisitSelected.timearrive">
                  <b>{{
                    formatDateTZ(plannedVisitSelected.timearrive, plannedVisitSelected.timezone, $store.state.auth.df.dateYearTime)
                  }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.plannedDeparture') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3 v-if="plannedVisitSelected.timearrive">
                  <b>{{
                    formatDateTZ(plannedVisitSelected.timedeparture, plannedVisitSelected.timezone, $store.state.auth.df.dateYearTime)
                  }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.area') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.areaName }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $t('label.note') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.note }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row v-if="plannedVisitSelected.approvalstatus < 10">
              <v-col>
                <v-text-field v-model="plannedVisitSelected.approvalnote" :label="$t('label.note')"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-sheet>
        <v-divider />
        <v-card-actions v-if="plannedVisitSelected.approvalstatus < 10">
          <v-col cols="6">
            <v-btn block color="green" @click="approveVisit(1)">
              {{ $tc('label.approve') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn block color="red" @click="approveVisit(2)">
              {{ $tc('label.reject') }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment-timezone';

import {
  mdiHelp,
  mdiCheckBold,
  mdiCloseThick,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiChevronDown,
  mdiClose,
  mdiAccountArrowLeft,
  mdiAccountArrowRight,
} from '@mdi/js';

export default Vue.extend({
  name: 'employee-approval',
  data: () => ({
    activeTab: 0,
    calValue: '',
    calEvents: [] as any[],
    calColors: ['grey', 'green', 'red'],
    calPeriod: 'month',
    tableData: [] as any[], // Hlavna tabulka ktora sa pouziva aj pri ukladani dat
    groupedVisits: [] as any[], // V groupovanom zobrazeni cez reaktivitu odovzdava zmeny do tableData
    groupView: true, // Zmena zobrazenia groupovanych udajov
    expanded: [] as any[],
    loaderStatus: false,
    listDocumentTypes: [] as any[],
    listEmployees: [
      {
        id: 0,
        fullName: '',
      },
    ],
    plannedVisitDetail: false,
    plannedVisitSelected: {
      id: 0,
      name: '',
      surname: '',
      phone: '',
      email: '',
      documentno: '',
      documenttype: '',
      companyname: '',
      carplate: '',
      cartype: '',
      carcolor: '',
      timearrive: '',
      timedeparture: '',
      timezone: '',
      areaName: '',
      employeeName: '',
      employeeSurname: '',
      plannerName: '',
      plannerSurname: '',
      note: '',
      approvalstatus: 0,
      approvalnote: '',
    },
    groupKeys: {} as { [key: string]: boolean },
    multiselect: false,
    mdiHelp: mdiHelp,
    mdiCheckBold: mdiCheckBold,
    mdiCloseThick: mdiCloseThick,
    mdiChevronLeft: mdiChevronLeft,
    mdiChevronRight: mdiChevronRight,
    mdiChevronUp: mdiChevronUp,
    mdiChevronDown: mdiChevronDown,
    mdiClose: mdiClose,
    mdiAccountArrowLeft: mdiAccountArrowLeft,
    mdiAccountArrowRight: mdiAccountArrowRight,
  }),
  computed: {
    weekdays: function () {
      return this.$store.state.auth.df.firstDayOfWeek === 0 ? [0, 1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5, 6, 0];
    },
    listPeriods: function () {
      return [
        { name: this.$i18n.tc('label.week'), value: 'week' },
        { name: this.$i18n.tc('label.month'), value: 'month' },
        { name: this.$i18n.tc('label.day'), value: 'day' },
      ];
    },
    headers: function () {
      return [
        { text: '', value: 'data-table-expand' },
        { text: this.$i18n.tc('label.visitor'), value: 'name' },
        { text: this.$i18n.tc('label.visiting'), value: 'employeeName' },
        { text: this.$i18n.tc('label.plannedBy'), value: 'plannerName' },
        { text: this.$i18n.tc('label.approvedBy'), value: 'approverName' },
        { text: this.$i18n.tc('label.area'), value: 'areaName' },
        { text: this.$i18n.tc('label.arrival'), value: 'timearrive' },
        { text: this.$i18n.tc('label.departure'), value: 'timedeparture' },
        { text: this.$i18n.tc('label.state'), sortable: false, width: '80px' },
      ];
    },
    groupHeaders: function () {
      return [
        { text: this.$i18n.tc('label.visitor'), sortable: false, value: 'name', class: 'blue-grey lighten-5' },
        { text: this.$i18n.tc('label.state'), sortable: false, class: 'blue-grey lighten-5' },
      ];
    },
  },
  mounted() {
    this.listDocumentTypesLoad();
    this.listEmployeesLoad().then(() => {
      this.dataLoad();
      this.calValue = this.$moment(new Date()).format('YYYY-MM-DD');
    });
  },
  methods: {
    getCalendarRef(): Vue & { next: () => void; prev: () => void } {
      return this.$refs.calendar as Vue & { next: () => void; prev: () => void };
    },
    viewDay(cdate: any) {
      this.calValue = cdate.date;
      this.calPeriod = 'day';
    },
    dataLoad() {
      this.loaderStatus = true;
      axios
        .get(`/api/v1/plannedvisits/approval`)
        .then((response) => {
          this.calEvents = [];
          for (const record of response.data) {
            record.checked = false;
            this.multiselect = false;
            const startTime = moment.utc(record.timearrive).tz(record.timezone).format('YYYY-MM-DD HH:mm');
            const endTime = moment.utc(record.timedeparture).tz(record.timezone).format('YYYY-MM-DD HH:mm');
            this.calEvents.push({
              id: record.id,
              name: record.name + ' ' + record.surname,
              start: startTime,
              end: endTime,
              color: record.approvalstatus,
              timed: true,
            });
          }
          // groupID, groupParentID
          // Get all parents - first record
          this.groupedVisits = [];
          for (const visit of response.data) {
            let found = false;
            for (const groupVisit of this.groupedVisits) {
              if (visit.groupID === groupVisit.groupID) {
                found = true;
                break;
              }
            }
            !found && visit.groupParentID === '' ? this.groupedVisits.push(structuredClone(visit)) : '';
          }
          // Find all records without parent (parent might be in a past)
          let nonParrentFoundGroup = response.data.filter((visit: any) => {
            return !this.groupedVisits.some(
              (groupVisit) => visit.groupParentID === groupVisit.groupID || visit.groupID === groupVisit.groupID,
            );
          });
          // Prepare unique non parent records
          const nonParrentFoundGroupUnique = nonParrentFoundGroup.filter(
            (item: any, index: any, self: any) => self.findIndex((t: any) => t.groupParentID === item.groupParentID) === index,
          );
          // Add all non parent records to groupedVisits (and set them as parent. SQL update not updating groupID or groupParentID)
          for (const v of nonParrentFoundGroupUnique) {
            v.groupID = v.groupParentID;
            v.groupParentID = '';
            this.groupedVisits.push(structuredClone(v));
          }
          // Get all children
          for (const groupVisit of this.groupedVisits) {
            groupVisit.children = [];
            for (const visit of response.data) {
              if (visit.groupParentID === groupVisit.groupID || visit.groupID === groupVisit.groupID) {
                groupVisit.children.push(visit);
              }
            }
            for (const child of groupVisit.children) {
              // More than one visitor in group (second case is one visitor multiple dates)
              if (child.name !== groupVisit.name || child.surname !== groupVisit.surname || child.documentNo !== groupVisit.documentNo) {
                groupVisit.isGroup = true;
                break;
              }
            }
            for (const child of groupVisit.children) {
              // If all statuses are not the same set 0 status
              if (child.approvalstatus !== groupVisit.approvalstatus) {
                groupVisit.approvalstatus = 0;
                break;
              }
            }
          }
          this.tableData = response.data;
          this.loaderStatus = false;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
          this.loaderStatus = false;
        });
    },
    approveMultiple(approvalStatus: number) {
      let selectedVisits = this.tableData.filter((item: any) => item.checked);
      selectedVisits = selectedVisits.map((item: any) => {
        item.approvalstatus = approvalStatus;
        return item;
      });
      axios
        .patch(`/api/v1/plannedvisits/approval`, selectedVisits)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      // set all groupKeys to false
      for (const groupKey in this.groupKeys) {
        this.groupKeys[groupKey] = false;
      }
    },
    approveVisit(approvalStatus: number) {
      this.plannedVisitSelected.approvalstatus = approvalStatus;
      axios
        .patch(`/api/v1/plannedvisits/approval`, [this.plannedVisitSelected])
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        })
        .finally(() => {
          this.plannedVisitDetail = false;
        });
    },
    listEmployeesLoad() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/employeebyauthoriser`)
          .then((response) => {
            for (const employee of response.data) {
              employee.fullName = employee.surname + ' ' + employee.name;
              if (employee.department != '') {
                employee.fullName = employee.fullName + ' (' + employee.department + ')';
              }
            }
            this.listEmployees = response.data;
            resolve(true);
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
            reject();
          });
      });
    },
    listDocumentTypesLoad() {
      axios
        .get('/api/v1/documenttype')
        .then((response) => {
          this.listDocumentTypes = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    getDocumentType(documenttype: string) {
      let document: any;
      for (document of this.listDocumentTypes) {
        if (documenttype === document.type) {
          return document.name;
        }
      }
      return '';
    },
    selectMultiple() {
      this.tableData.forEach((item) => (item.approvalstatus == 0 ? (item.checked = this.multiselect) : (item.checked = false)));
    },
    calShowEvent(calEvent: any) {
      for (const visit of this.tableData) {
        if (visit.id === calEvent.event.id) {
          this.plannedVisitSelected = visit;
          this.plannedVisitDetail = true;
        }
      }
    },
    getEventColor(event: { color: number }) {
      return event.color > 9 ? 'grey' : this.calColors[event.color];
    },
    exportToCSV() {
      const d = ',';
      // headers `"name";"surname";"phone";"email";"documentno";"documenttype";"companyname";"carplate";"timearrive";"timedeparture";"areaName";"employeeName";"employeeSurname";"plannerName";"note"\r\n`;
      let csv = '\ufeff'; // BOM koli excelu
      csv += `"${this.$i18n.tc('label.name')}"${d}`;
      csv += `"${this.$i18n.tc('label.surname')}"${d}`;
      csv += `"${this.$i18n.tc('label.phone')}"${d}`;
      csv += `"${this.$i18n.tc('label.email')}"${d}`;
      csv += `"${this.$i18n.tc('label.documentno')}"${d}`;
      csv += `"${this.$i18n.tc('label.documentType')}"${d}`;
      csv += `"${this.$i18n.tc('label.company')}"${d}`;
      csv += `"${this.$i18n.tc('label.car')}"${d}`;
      csv += `"${this.$i18n.tc('label.arrival')}"${d}`;
      csv += `"${this.$i18n.tc('label.departure')}"${d}`;
      csv += `"${this.$i18n.tc('label.area')}"${d}`;
      csv += `"${this.$i18n.tc('label.visiting')}"${d}`;
      csv += `"${this.$i18n.tc('label.plannedBy')}"${d}`;
      csv += `"${this.$i18n.tc('label.note')}"\r\n`;

      this.tableData.forEach((row: any) => {
        csv += `"${row.name}"${d}`;
        csv += `"${row.surname}"${d}`;
        csv += `"${row.phone}"${d}`;
        csv += `"${row.email}"${d}`;
        csv += `"${row.documentno}"${d}`;
        csv += `"${row.documenttype}"${d}`;
        csv += `"${row.companyname === null ? '' : row.companyname}"${d}`;
        csv += `"${row.carplate === null ? '' : row.carplate}"${d}`;
        csv += `"${moment.utc(row.timearrive).tz(row.timezone).format(this.$store.state.auth.df.dateYearTime)}"${d}`;
        csv += `"${moment.utc(row.timedeparture).tz(row.timezone).format(this.$store.state.auth.df.dateYearTime)}"${d}`;
        csv += `"${row.areaName}"${d}`;
        csv += `"${row.employeeName} ${row.employeeSurname}"${d}`;
        csv += `"${row.plannerName} ${row.plannerSurname}"${d}`;
        csv += `"${row.note}"\r\n`;
      });

      /*   
      const replacer = (key: any, value: any) => (value === null ? '' : value); // specify how you want to handle null values here
      const header = Object.keys(this.tableData[0]);
      let csv: any = this.tableData.map((row: any) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(';'));
      csv.unshift(header.join(';'));
      csv = csv.join('\r\n');
      */

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'export.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatDate(date: string, format: string) {
      return this.$moment(date).format(format);
    },
    formatDateTZ(date: string, timeZone: string, format: string) {
      return this.$moment(date).tz(timeZone).format(format);
    },
    expandRow(item: any) {
      if (this.expanded.length > 0) {
        if (item.id === this.expanded[0].id) {
          this.expanded = [{}];
        } else {
          this.expanded = [{}];
          this.$nextTick(() => {
            // wait for the data to be updated
            this.expanded = [item];
          });
        }
      } else {
        this.expanded.push(item);
      }
    },
    groupAllChildsCheck(item: any) {
      for (const child of item.children) {
        child.checked = item.checked;
      }
    },
    groupDaysCheck(groupID: string) {
      for (const visit of this.tableData) {
        if (visit.groupID === groupID) {
          visit.checked = this.groupKeys[groupID];
        }
      }
    },
    openPlannedVisitDetail(item: any) {
      // If no childrens - it's child record
      if (item.children === undefined) {
        this.plannedVisitSelected = item;
        this.plannedVisitDetail = true;
        return;
      }
      // If more than one children - group record
      if (item.children.length > 1) {
        return;
      }
      // If just on child - it's single record
      this.plannedVisitSelected = item;
      this.plannedVisitDetail = true;
    },
    multiselectCheck() {
      this.groupView
        ? this.groupedVisits.forEach((item) => ((item.checked = this.multiselect), this.groupAllChildsCheck(item)))
        : this.tableData.forEach((item) => (item.checked = this.multiselect));
    },
  },
});
</script>
